const REFERRAL_PROGRAM_FIELDS = `
  eligible
  status
  shareUrl
  linkCode
  qualifiedCount
  pendingCount
  totalCount
  threshold
  remainingCount
  inProgress
  rewardAvailable
  rewardStatus
  rewardLabel
  rewardPlanTier
  rewardValueCents
  rewardDisplayLabel
  rewardProvider
  rewardRedemptionKind
  rewardOfferDescription
  rewardOfferIdentifier
  shouldShowPrompt
  promptKind
  terms
  referrals {
    status
    maskedEmail
    emailConfirmedAt
    firstQuestionAt
    qualifiedAt
    createdAt
  }
  nextPromptEligibleAt
`;

const postGraphql = async (query, variables = {}) => {
  try {
    const response = await fetch("/graphql", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables }),
    });
    const json = await response.json();
    if (json.errors && json.errors.length) {
      return { error: json.errors[0]?.message || "Referral request failed" };
    }
    return json.data;
  } catch (error) {
    console.error("referral api error:", error);
    return { error: "Referral request failed" };
  }
};

export const getReferralProgram = async () => {
  const data = await postGraphql(`
    query ReferralProgram {
      referralProgram {
        ${REFERRAL_PROGRAM_FIELDS}
      }
    }
  `);
  return data?.referralProgram || data;
};

export const ensureReferralLink = async (surface = "account") => {
  const data = await postGraphql(`
    mutation EnsureReferralLink($surface: String) {
      ensureReferralLink(surface: $surface) {
        ${REFERRAL_PROGRAM_FIELDS}
      }
    }
  `, { surface });
  return data?.ensureReferralLink || data;
};

export const recordReferralLinkCopied = async (surface = "account") => {
  const data = await postGraphql(`
    mutation RecordReferralLinkCopied($surface: String) {
      recordReferralLinkCopied(surface: $surface) {
        ${REFERRAL_PROGRAM_FIELDS}
      }
    }
  `, { surface });
  return data?.recordReferralLinkCopied || data;
};

export const recordReferralNativeShareStarted = async (surface = "account") => {
  const data = await postGraphql(`
    mutation RecordReferralNativeShareStarted($surface: String) {
      recordReferralNativeShareStarted(surface: $surface) {
        ${REFERRAL_PROGRAM_FIELDS}
      }
    }
  `, { surface });
  return data?.recordReferralNativeShareStarted || data;
};

export const dismissReferralPrompt = async (surface = "chat") => {
  const data = await postGraphql(`
    mutation DismissReferralPrompt($surface: String) {
      dismissReferralPrompt(surface: $surface) {
        ${REFERRAL_PROGRAM_FIELDS}
      }
    }
  `, { surface });
  return data?.dismissReferralPrompt || data;
};
